import { IRadicadoEntrada, defaultIRadicadoEntrada } from "../ioip/sdk/base";

export interface IRadicadoEntradaExtended extends IRadicadoEntrada {
    AutorizaTratamientoDatosPersonales: boolean;
    AutorizaPoliticaPrivacidad: boolean;
    Estado: string;
    IdRadicadoSalida: number;
    EstadoRadicadoSalida: string;
    IdEstadoActualRadicadoSalida: number;
    AclaracionCompleta: number;
    IdTipoRespuestaPQRS: number;
    RadicaRepresentante: boolean;
    DenuncianteAnonimo: boolean;
    SolicitanteConDiscapacidad: boolean;
    NombresApoderado: string;
    ApellidosApoderado: string;
    IdTipoIdentificacionApoderado: number;
    IdentificacionApoderado: string;
    EmailApoderado: string;
    FechaCreacionString: string;
    CorreoElectronicoContacto : string;
    NombreEntidadAdscrita : string;
    NombreContactoEntidadAdscrita : string;
    Observaciones:string;
    OtroClasificacionPQR: string;
}

export function defaultIRadicadoEntradaExtended(): IRadicadoEntradaExtended {
    return {
        ...defaultIRadicadoEntrada(),
        AutorizaPoliticaPrivacidad: false,
        AutorizaTratamientoDatosPersonales: false,
        Estado: '',
        IdRadicadoSalida: 0,
        EstadoRadicadoSalida: '',
        IdEstadoActualRadicadoSalida: 0,
        AclaracionCompleta: 0,
        IdTipoRespuestaPQRS: 0,
        RadicaRepresentante: false,
        DenuncianteAnonimo: false,
        SolicitanteConDiscapacidad: false,
        NombresApoderado: '',
        ApellidosApoderado: '',
        IdTipoIdentificacionApoderado: 0,
        IdentificacionApoderado: '',
        EmailApoderado: '',
        FechaCreacionString: '',
        NombreContactoEntidadAdscrita:'',
        CorreoElectronicoContacto : '',
        NombreEntidadAdscrita : '',
        Observaciones:'',
        OtroClasificacionPQR: ''
    }
}